import { useState } from "react";
import { strategyGraphData, FilterData } from "./NewStatergy";
import { valueGraphData } from "../ValueStatergy/ValueStatergy";

interface BacktestingTableProps {
  statergyGraphData?: strategyGraphData | null;
  valueGraphData?: valueGraphData | null;
}

const BacktestingTable = ({
  statergyGraphData,
  valueGraphData,
}: BacktestingTableProps) => {
  const [sortConfig, setSortConfig] = useState<{
    key: "parameter" | "ourStocksValue" | "niftybeesValue";
    direction: "ascending" | "descending";
  } | null>(null);

  const getFilteredData = () => {
    const filterData: FilterData | undefined =
      statergyGraphData?.["Filter 3 6STOCKS MaxSharpe"] ||
      valueGraphData?.["Filter 3"];

    if (
      !filterData ||
      !filterData["Normalized Price Over Time STOCKS"] ||
      !filterData["Normalized Price Over Time INDICES"]
    ) {
      return null;
    }

    const ourStocksParameters: Record<string, unknown> =
      filterData?.["Our Stocks Parameters"] || {};
    const niftybeesParameters: Record<string, unknown> =
      filterData?.["NIFTYBEES Parameters"] || {};

    const mergedParameters = { ...ourStocksParameters, ...niftybeesParameters };

    return Object.keys(mergedParameters).map((key) => ({
      parameter: key,
      ourStocksValue: ourStocksParameters[key],
      niftybeesValue: niftybeesParameters[key],
    }));
  };

  const handleSort = (key: "parameter" | "ourStocksValue" | "niftybeesValue") => {
    let direction: "ascending" | "descending" = "ascending";
    if (sortConfig?.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const getSortIcon = (key: string) => {
    if (!sortConfig || sortConfig.key !== key) return " ↕";
    return sortConfig.direction === "ascending" ? " ↑" : " ↓";
  };

  const getSortedData = (data: ReturnType<typeof getFilteredData>) => {
    if (!data || !sortConfig) return data;
    return [...data].sort((a, b) => {
      const aVal = a[sortConfig.key];
      const bVal = b[sortConfig.key];
      if (typeof aVal === "number" && typeof bVal === "number") {
        return sortConfig.direction === "ascending" ? aVal - bVal : bVal - aVal;
      }
      return sortConfig.direction === "ascending"
        ? String(aVal ?? "").localeCompare(String(bVal ?? ""))
        : String(bVal ?? "").localeCompare(String(aVal ?? ""));
    });
  };

  const rawData = getFilteredData();
  const tableData = getSortedData(rawData);

  return (
    <div className="bt-table-wrapper">
      <table className="bt-table">
        <thead>
          <tr>
            <th onClick={() => handleSort("parameter")}>Parameter{getSortIcon("parameter")}</th>
            <th onClick={() => handleSort("ourStocksValue")}>Momentum{getSortIcon("ourStocksValue")}</th>
            <th onClick={() => handleSort("niftybeesValue")}>Nifty{getSortIcon("niftybeesValue")}</th>
          </tr>
        </thead>
        <tbody>
          {tableData?.map((data) => (
            <tr key={data.parameter}>
              <td>{data.parameter}</td>
              <td>{String(data.ourStocksValue ?? "")}</td>
              <td>{String(data.niftybeesValue ?? "")}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BacktestingTable;
